import dashboardArchitectureImage from '../../../assets/common/architecture_summary.png';
import dashboardBetaTestImage from '../../../assets/common/beta-test.svg';
import BGPattern from '../../../assets/common/bg-pattern.svg';
import dashboardGoLiveImage from '../../../assets/common/go-live.svg';
import dashboardIntro1 from '../../../assets/common/introduction-intro-1.svg';
import dashboardIntro2 from '../../../assets/common/introduction-intro-2.svg';
import dashboardPreRequisitesImage from '../../../assets/common/prerequisites.svg';
import dashboardProductionReadinessImage from '../../../assets/common/production-readiness.svg';
import activateProduct from '../../../assets/netlync/activate-product.svg';
import dashboardEntitlementsHeader from '../../../assets/netlync/dashboard-entitlements-header.svg';
import dontUseEntitlementServer from '../../../assets/netlync/dont-use-entitlement-server.svg';
import entitlementsGetStarted from '../../../assets/netlync/entitlements-get-started.png';
import entitlementsGetStarted2 from '../../../assets/netlync/entitlements-get-started-2.svg';
import backgroundLoginImage from '../../../assets/netlync/login-background.svg';
import logo from '../../../assets/netlync/logo.svg';
import logoLight from '../../../assets/netlync/logo-light.svg';
import logoMini from '../../../assets/netlync/logo-mini.svg';
import useEntitlementServer from '../../../assets/netlync/use-entitlement-server.svg';
import { Config } from './types/brands';

export const netlyncConfig: Config = {
  context: 'netlync',
  assets: {
    activateProduct,
    backgroundLoginImage,
    dashboardEntitlementsHeader,
    dontUseEntitlementServer,
    entitlementsGetStarted,
    entitlementsGetStarted2,
    logoMini,
    logo,
    logoLight,
    useEntitlementServer,
    onboarding: {
      dashboardIntro1,
      dashboardIntro2,
      architecture: dashboardArchitectureImage,
      prerequisites: dashboardPreRequisitesImage,
      productionReadiness: dashboardProductionReadinessImage,
      betaTest: dashboardBetaTestImage,
      goLive: dashboardGoLiveImage,
    },
    reviewBgPattern: BGPattern,
  },
  i18n: {
    variables: {
      companyName: 'NetLync',
      productName: 'NetLync ES',
      productFullName: 'NetLync Entitlements',
      portalFullName: 'NetLync Entitlements Developer Portal',
      saasFullName: 'NetLync Entitlements as a Service',
      supportEmail: 'support@netlync.com',
      productionSupportEmail: 'productionsupport@netlync.com',
      productionSupportTickets: 'productionsupport@netlync.com',
      uesContractUrl: '',
    },
  },
  environments: {
    settings: {
      companyFlag: 'NetLync',
      sideMenuLogoHeight: '55px',
      sideMenuLogoPadding: '12px 0',
      termOfServiceUrl: 'https://www.netlync.com/terms-and-conditions',
      privacyPolicyURL: 'https://www.netlync.com/privacy-policy',
      cookiesPolicyURL: '/cookie-policy',
      imprintUrl: undefined,
      poweredBy: undefined,
    },
  },
};
